import {Component, Input, OnInit} from '@angular/core';
import { TablaComponent } from '../../../../../core/components/tabla/tabla.component';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { Ciudadano } from '../../../../../core/interfaces/utilidades/pNatural.interface';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { PNaturalService } from '../../../../../core/services/p-natural.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {
  FormularioGeneralComponent
} from '../../../../../core/components/formulario-general/formulario-general.component';
import {Validators} from '@angular/forms';

@Component({
  selector: 'app-ciudadanos',
  imports: [
    TablaComponent,
    NzIconDirective,
    NzButtonComponent,
    NzModalModule
  ],
  templateUrl: './ciudadanos.component.html',
  styleUrls: ['./ciudadanos.component.css']
})
export class CiudadanosComponent implements OnInit {

  constructor(private modal: NzModalService, private pnaturalService: PNaturalService,private message: NzMessageService) {}
  columns = [
    { title: 'Nombre', key: 'nombre_persona' },
    { title: 'DNI', key: 'dni' },
    { title: 'Celular', key: 'celular' },
  ];

  listOfData: Ciudadano[] = [];

  ngOnInit(): void {
    this.loadCiudadanos();
  }

  loadCiudadanos(): void {
    this.pnaturalService.getCiudadanos().subscribe(
      (ciudadano) => {
        this.listOfData = ciudadano;
      },
      (error) => {
        console.error('Error al cargar los ciudadanos', error);
      }
    );
  }
  formConfig = {
    nombre_persona: { label: 'Nombre', validators: [] },
    dni: { label: 'DNI', validators: [] },
    celular: { label: 'Celular', validators: [] },
  };
  showModal(): void {
    const modalRef = this.modal.create({
      nzTitle: 'Nuevo Ciudadano',
      nzContent: FormularioGeneralComponent,
      nzData: {
        formConfig: this.formConfig, // Usa el mismo formConfig
        service: this.pnaturalService,
      },
      nzFooter: null,
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success('Ciudadano creado exitosamente');
        this.loadCiudadanos();
      }
    });
  }



  onEdit(row: Ciudadano): void {
    const modalRef = this.modal.create({
      nzTitle: 'Editar Ciudadano',
      nzContent: FormularioGeneralComponent,
      nzFooter: null,
      nzData: {
        formConfig: this.formConfig, // Configuración del formulario
        initialData: row, // 🔹 Pasamos los datos actuales para edición
        service: this.pnaturalService, // 🔹 Pasamos el servicio
      },
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success('Ciudadano editado exitosamente');
        this.loadCiudadanos(); // Recarga la tabla después de editar
      }
    });
  }




  onDelete(row: Ciudadano): void {
    this.pnaturalService.deleteCiudadano(row.id_persona_natural).subscribe(
      () => {
        console.log('Ciudadano eliminado');
        this.loadCiudadanos(); // Reload the data after deletion
      },
      (error) => {
        console.error('Error al eliminar el ciudadano:', error);
      }
    );
  }
}
